import React from 'react';
import {Button, Heading, Text} from '@albert-io/atomic';
import {Link} from 'react-router';

import './author-dashboard-activity.scss';

const AuthorDashboardNew = () => {
  return (
    <div className='author-dashboard-activity__new-account'>
      <Heading size='m' className='u-mar-b_2'>
        Let&apos;s get started!
      </Heading>
      <Text emphasis='medium' size='regular' className='u-mar-b_4'>
        <div>
          Once you’ve created and published your first question, your dashboard will show you
          comments, status changes, recent questions, and metrics on your contributions.
        </div>
        <div className='u-mar-t_2'>Head over to the Authoring Queue to create a new question!</div>
      </Text>
      <Link to='/authoring/queue' className='author-dashboard-activity__queue-button'>
        <Button color='secondary'>Go to authoring queue</Button>
      </Link>
    </div>
  );
};

export default AuthorDashboardNew;
